/**
 * Utility functions for tenant management
 */

/**
 * Extracts the subdomain from the current window location
 * @returns The subdomain string or null if no subdomain
 */
export const getSubdomain = (): string | null => {
  const hostname = window.location.hostname;
  
  // Split the hostname by dots
  const parts = hostname.split('.');
  
  // Handle localhost development with subdomains (e.g., victorkhanye.localhost)
  if (hostname.includes('localhost') && parts.length >= 2) {
    // If it's just localhost, return null
    if (parts[0] === 'localhost') {
      return null;
    }
    // Return the subdomain part
    return parts[0];
  }
  
  // For production URLs, check if this is the base domain or has a subdomain
  if (parts.length >= 3) {
    const potentialSubdomain = parts[0];
    
    // Check if this is the base gensize.co.za domain (no subdomain)
    if (hostname === 'gensize.co.za' || potentialSubdomain === 'www') {
      return null;
    }
    
    // Otherwise, return the first part as subdomain
    return potentialSubdomain;
  }
  
  // If we only have 2 parts (domain.tld), there's no subdomain
  return null;
};

/**
 * Gets the tenant header value based on the current subdomain
 * @returns The tenant header value or null if no tenant
 */
export const getTenantHeader = (): string | null => {
  return getSubdomain();
};
